import { Model } from "@ofqual/portal-core/core/types";
import { Attachment } from "./Attachment";

export type News = {
  id: string;
  title: string;
  subHeading: string;
  excerpt: string;
  content: string;
  publishedDate: string;
  imageSrc: string;
  videoEmbed: string;
  archived: boolean;
  createdDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedDate: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  newsItemAttachments: Attachment[];
  resourceTags: number[];
  link: string;
  rssId: string;
  type: NewsType;
};

export enum NewsType {
  GovUk = 0,
  Ofqual = 1,
  CceaRegulator = 2,
  DfE = 3,
  IFATE = 4
}
export const fromApiModel = (apiModel: Model) => {
  return apiModel as News;
};
